import React from "react"

import Head from "@components/Head"
import Container from "@components/v2/Container"

const Privacy = () => {
    return (
        <>
            <Head title='Kebijakan Privasi' />
            <Container>
                <div className='flex flex-col px-6 pt-2'>
                    <span className='text-center text-main dark:text-dark-main font-bold'>KEBIJAKAN PRIVASI</span>
                    <span className='paragraph-4 text-main dark:text-dark-main'>
                        Demi kelancaran pemrosesan transaksi dan proses pendaftaran, maka Pengguna memberikan
                        persetujuan mengenai Kebijakan Privasi yang diperlukan oleh Pasar FX , seperti:
                        <ol className='list-decimal list-inside'>
                            <li className='py-2'>
                                Pengguna memberikan persetujuan dan kuasa kepada Pasar FX mengenai informasi dan data
                                mengenai Pengguna apabila data tersebut diperlukan oleh:
                                <ol className='list-disc list-inside pl-4'>
                                    <li className='py-2'>
                                        Instansi pemerintah berdasarkan ketentuan hukum Republik Indonesia yang mengatur
                                        mengenai data privasi dan informasi Pengguna;
                                    </li>
                                    <li className='pb-2'>
                                        Pihak ketiga dan/atau mitra usaha yang dimana Pengguna menggunakan layanan dari
                                        pihak ketiga dan/atau mitra usaha, termasuk mitra usaha yang mengintegrasikan
                                        API, mitra usaha Pasar FX yang bekerjasama untuk melaksanakan promosi, dan mitra
                                        usaha yang terkait mengenai pemrosesan transaksi dan proses pendaftaran yang
                                        dilakukan oleh Pengguna;
                                    </li>
                                    <li className='pb-2'>
                                        Afiliasi dari Pasar FX yang mempunyai kaitan dengan proses pendaftaran dan
                                        transaksi yang dilakukan oleh Pengguna;
                                    </li>
                                    <li className='pb-2'>
                                        Pengguna memberikan izin kepada Pasar FX untuk mengumpulkan dan menyimpan data
                                        dan informasi transaksi untuk kepentingan transaksi yang dilakukan oleh
                                        Pengguna. Atas hal ini Pasar FX menggunakan data tersebut untuk dapat mengolah
                                        data tersebut untuk dijadikan suatu ringkasan transaksi yang dapat diakses oleh
                                        Pengguna sewaktu-waktu.
                                    </li>
                                    <li className='pb-2'>
                                        Pengguna secara sadar memahami dan sepakat untuk membebaskan Pasar FX dari
                                        segala kerugian yang mungkin timbul dan tuntutan, gugatan, klaim, serta hal
                                        lainnya yang mungkin diderita oleh Pengguna akibat pemberian data dan informasi
                                        Pengguna kepada pihak yang telah dijelaskan diatas.
                                    </li>
                                </ol>
                            </li>
                            <li className='pb-2'>
                                Persetujuan dan kuasa yang diberikan dari Pengguna kepada Pasar FX sebagaimana yang
                                telah dijelaskan pada poin diatas tidak dapat digugat dan ditarik kembali oleh Pengguna.
                            </li>
                        </ol>
                        <br />
                        <strong>PENDAFTARAN DAN PEMBUKAAN AKUN SECARA ELEKTRONIK</strong>
                        <br />
                        Demi kepentingan proses pendaftaran dan pembukaan akun secara elektronik, Pasar FX melalui Reku
                        akan menyediakan beberapa dokumen yang telah disediakan oleh Bappebti. <br />
                        <br />
                        Pengguna telah membaca, memahami, melengkapi, dan menyetujui secara hati-hati dan menyertakan
                        data pribadi untuk kepentingan pendaftaran dan pembukaan akun secara elektronik di Pasar FX
                        melalui Platform. Dokumen yang harus dibaca, dipahami, dilengkapi, dan disetujui oleh Pengguna
                        adalah:
                        <ol className='list-decimal list-inside pl-4'>
                            <li className='py-1'>Profil Perusahaan Pasar FX;</li>
                            <li className='pb-1'>
                                Surat Pernyataan Telah Melakukan Simulasi Perdagangan Berjangka Komoditi;
                            </li>
                            <li className='pb-1'>Pernyataan Pengungkapan (Disclosure Statement);</li>
                            <li className='pb-1'>Formulir Pembukaan Rekening Transaksi Secara Elektronik;</li>
                            <li className='pb-1'>
                                Dokumen Pemberitahuan Adanya Risiko Yang Harus Disampaikan Oleh Pialang Berjangka Untuk
                                Transaksi Kontrak Berjangka;
                            </li>
                            <li className='pb-1'>
                                Perjanjian Pemberian Amanat Secara Elektronik Online Untuk Transaksi Kontrak Berjangka;
                            </li>
                            <li className='pb-1'>
                                Peraturan dan Ketentuan Transaksi Penyaluran Amanat Luar Negeri Produk Saham Tunggal
                                Asing (Trading Rules);
                            </li>
                            <li className='pb-1'>
                                Pernyataan Bertanggung Jawab Atas Kode Akses Transaksi Nasabah (Personal Access
                                Password);
                            </li>
                            <li className='pb-1'>
                                Pernyataan Bahwa Dana Yang Digunakan Sebagai Margin Merupakan Dana Milik Nasabah Sendiri
                            </li>
                        </ol>
                        <br />
                        Pasar FX mempunyai hak untuk menolak proses pendaftaran dan pembukaan akun yang diajukan
                        sebelumnya oleh Pengguna melalui Platform apabila Pengguna tidak memberikan persetujuan, tidak
                        menyertakan, tidak memahami, dan tidak melengkapi dokumen yang dibutuhkan oleh Bappebti untuk
                        proses pendaftaran dan pembukaan akun secara elektronik. <br /> <br />
                        <strong>PERATURAN TRANSAKSI DAN PENGHENTIAN TRANSAKSI</strong>
                        <br />
                        Produk komoditi berjangka yang difasilitasi oleh Pasar FX melalui Platform adalah kewenangan
                        dari Pasar FX selaku memiliki izin sebagai pialang berjangka sehingga dapat melakukan kegiatan
                        transaksi untuk PALN. Untuk mematuhi ketentuan atas Peraturan Yang Berlaku, Pengguna diwajibkan
                        untuk membaca, memahami, dan sepakat atas trading rules yang ditentukan oleh Pasar FX. Dengan
                        menggunakan fasilitas transaksi Pasar FX melalui Platform, maka Pengguna telah membaca,
                        memahami, menyetujui, dan sepakat atas trading rules berikut ini sebagaimana tercantum dalam
                        link ini [X]
                        <br />
                        <br />
                        Pasar FX dapat memberhentikan kegiatan transaksi atas produk komoditi berjangka yang dilakukan
                        dengan menyampaikan pemberitahuan terlebih dahulu kepada Pengguna tanpa adanya kewajiban meminta
                        persetujuan terlebih dahulu dari Pengguna. Proses pemberhentian transaksi tersebut terbagi
                        menjadi 2 (dua) skema, yaitu:
                        <ol className='list-decimal list-inside'>
                            <li className='py-1'>
                                Dihentikan secara sementara; dan
                                <ol className='list-disc list-inside pl-4'>
                                    <li className='py-1'>
                                        Pengguna melakukan permohonan kepada Pasar FX melalui Platform untuk
                                        menghentikan akses kegiatan transaksi untuk sementara waktu;
                                    </li>
                                    <li className='pb-1'>
                                        Pengguna salah memasukan kode akses sebanyak 3 (tiga) kali; dan
                                    </li>
                                    <li className='pb-1'>
                                        Terdapat Peraturan Yang Berlaku dari regulator untuk melakukan penghentian
                                        secara sementara terhadap akun Pengguna.
                                    </li>
                                </ol>
                            </li>
                            <li className='py-1'>
                                Dihentikan secara permanen.
                                <ol className='list-disc list-inside pl-4'>
                                    <li className='py-1'>
                                        Pengguna melakukan permohonan kepada Pasar FX melalui Platform untuk
                                        menghentikan akses kegiatan transaksi secara permanen;
                                    </li>
                                    <li className='pb-1'>
                                        Pengguna menutup akun yang telah terdaftar di Pasar FX; dan
                                    </li>
                                    <li className='pb-1'>
                                        Terdapat Peraturan Yang Berlaku dari regulator untuk melakukan penghentian
                                        secara permanen terhadap akun Pengguna.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <br />
                        <strong>KEADAAN KAHAR</strong>
                        <ol className='list-decimal list-inside'>
                            <li className='py-1'>
                                Pasar FX tidak akan bertanggung jawab kepada Pengguna dan tidak dianggap melanggar
                                Perjanjian ini apabila adanya keterlambatan dalam melaksanakan atau kegagalan untuk
                                melaksanakan kewajibannya jika keterlambatan atau kegagalan tersebut disebabkan oleh
                                peristiwa atau kejadian di luar kendali wajarnya. Berikut ini yang dianggap sebagai
                                sebab-sebab diluar kendali wajar Pasar FX (“Keadaan Kahar”):
                                <ol className='list-inside  pl-4'>
                                    <li className='py-1'>
                                        Kuasa Tuhan, ledakan, banjir, prahara, atau kebakaran, angin topan;
                                    </li>
                                    <li className='pb-1'>
                                        Perang atau ancaman perang, sabotase, huru-hara, kekacauan atau pengambilalihan
                                        sipil, aksi terorisme, atau kerusuhan sipil;
                                    </li>
                                    <li className='pb-1'>Undang-undang, batasan dan regulasi;</li>
                                    <li className='pb-1'>Aksi industri dan pemogokan massal; dan</li>
                                    <li className='pb-1'>
                                        Wabah penyakit yang ditetapkan oleh Organisasi Kesehatan Dunia (WHO).
                                    </li>
                                </ol>
                            </li>
                            <li className='py-1'>
                                Dalam hal terjadi Keadaan Kahar, Pasar FX akan memberitahukan secara tertulis keadaan
                                tersebut kepada Pengguna selambat-lambatnya 3 (tiga) hari kalender sejak terjadinya
                                Keadaan Kahar tersebut.
                            </li>
                        </ol>
                        <br />
                        <strong>GANTI KERUGIAN</strong>
                        <br />
                        Pasar FX tidak akan bertanggung jawab atas semua kerugian, klaim, tuntutan, gugatan, dan hal
                        lainnya yang mungkin dialami oleh Pengguna atas tindakan yang dilakukan oleh Pengguna mengenai
                        kegiatan transaksi pasar saham Amerika Serikat dan/atau produk komoditas berjangka lainnya,
                        kecuali kerugian tersebut terjadi akibat kesalahan yang disengaja dari Pasar FX. Pengguna secara
                        sadar secara penuh akan membebaskan Pasar FX atas segala tindakan yang dilakukannya, termasuk
                        afiliasi, pemegang saham, direksi, dan karyawan dari segala tuntutan, gugatan, klaim, kerugian
                        yang mungkin diderita oleh Pengguna baik secara langsung atau tidak langsung yang berkaitan
                        dengan kegiatan transaksi.
                        <br />
                        <br />
                        <strong>BIAYA YANG TIMBUL</strong>
                        <br />
                        Pengguna akan bertanggung jawab atas segala biaya, kerugian, klaim, dan hal lainnya yang akan
                        timbul dan mungkin akan diderita oleh Pengguna akibat kegiatan transaksi produk komoditas
                        berjangka atau yang ditimbulkan dari proses transaksi yang akan dilakukan.
                        <br />
                        <br />
                        <strong>PERNYATAAN DAN JAMINAN</strong>
                        <br />
                        Bahwa Pengguna menyatakan dan menjamin kepada Pasar FX bahwa:
                        <ol className='list-decimal list-inside pl-4'>
                            <li className='py-1'>
                                Pengguna ialah Badan dan/atau Perorangan yang sah dan dapat melakukan kegiatan dan
                                tanggung jawab hukum;
                            </li>
                            <li className='pb-1'>
                                Tidak akan bertentangan dengan Peraturan Yang Berlaku, peraturan perundang-undangan,
                                putusan pengadilan, dan hukum positif yang berlaku saat ini di Republik Indonesia.
                            </li>
                            <li className='pb-1'>
                                Tidak sedang dalam proses PKPU dan tidak pernah dinyatakan pailit oleh putusan
                                pengadilan; dan
                            </li>
                            <li className='pb-1'>
                                Tidak akan melanggar ketentuan yang diberikan oleh Pasar FX sebagai penyelenggara dari
                                produk berjangka komoditas.
                            </li>
                        </ol>
                        <br />
                        <strong>LAINNYA</strong>
                        <br />
                        <ol className='list-decimal list-inside pl-4'>
                            <li className='py8-1'>
                                Pengguna memberikan persetujuan telah memahami, membaca, dan melengkapi dokumen yang
                                dibutuhkan guna kepentingan proses pendaftaran.
                            </li>
                            <li className='pb-1'>
                                Apabila terdapat perubahan, modifikasi, atau penambahan terdapat SK PALN ini maka akan
                                diubah secara sepihak oleh Pasar FX melalui Platform dengan memberikan keterangan revisi
                                pada SK PALN.
                            </li>
                            <li className='pb-1'>
                                SK PALN ini diatur dan ditafsirkan menurut hukum Republik Indonesia.
                            </li>
                            <li className='pb-1'>
                                Pengguna dengan ini menyatakan dan menyetujui dan memberikan kuasa kepada Reku untuk
                                menjalankan hak yang mungkin akan timbul terkait kegiatan transaksi mengenai produk
                                komoditas berjangka.
                            </li>
                            <li className='pb-1'>
                                Setiap adanya tuntutan, gugatan, klaim, dan pertentangan yang timbul dikarenakan adanya
                                pelanggaran atas Perjanjian ini maka Para Pihak sepakat akan menyelesaikan perselisihan
                                secara musyawarah untuk mencapai mufakat. Apabila dalam waktu 30 (tiga puluh) hari
                                kalender perselisihan tidak dapat diselesaikan, maka Para Pihak sepakat perselisihan
                                akan diselesaikan di Badan Arbitrase Nasional Indonesia (“BANI”) yang beralamat di
                                Wahana Graha Lt. 1 & 2, Jalan Mampang Prapatan No. 2, Jakarta. Proses penyelesaian
                                perselisihan ini akan bertempat di Jakarta dan akan diselesaikan dengan peraturan BANI.
                            </li>
                        </ol>
                    </span>
                </div>
            </Container>
        </>
    )
}

export default Privacy
